import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { axiosBuzzOne } from '../../axios';
const moduleName = 'buzzOne';

export const getAllBuzzOneSchools = createAsyncThunk(
  `GET/${moduleName}/schools`,
  async (paylaod, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'GET',
        url: '/buzz1/schools',
      });
      const data = response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const createBuzzOneSchool = createAsyncThunk(
  `POST/${moduleName}/schools`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'POST',
        url: '/buzz1/schools',
        data: payload,
      });
      const data = response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateBuzzOneSchool = createAsyncThunk(
  `PUT/${moduleName}/schools`,
  async (payload, { rejectWithValue }) => {
    try {
      const { id, data } = payload;
      const response = await axiosBuzzOne({
        method: 'PUT',
        url: `/buzz1/schools/${id}`,
        data: { ...data },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getSchoolStaffs = createAsyncThunk(
  `GET/${moduleName}/school/staffs`,
  async (payload, { rejectWithValue }) => {
    try {
      const { schoolId } = payload;
      const response = await axiosBuzzOne({
        method: 'GET',
        url: `/buzz1/schools/${schoolId}/staffs`,
      });
      const data = response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const addUserToSchool = createAsyncThunk(
  `POST/${moduleName}/schools/staffs`,
  async (payload, { rejectWithValue }) => {
    try {
      const { schoolId, data } = payload;
      const response = await axiosBuzzOne({
        method: 'POST',
        url: `/buzz1/schools/${schoolId}/staffs`,
        data,
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getSchoolStudents = createAsyncThunk(
  `GET/${moduleName}/school/students`,
  async (payload, { rejectWithValue }) => {
    try {
      const { schoolId } = payload;
      const response = await axiosBuzzOne({
        method: 'GET',
        url: `/buzz1/schools/${schoolId}/students`,
      });
      const data = response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const addStudentAndParentToSchool = createAsyncThunk(
  `POST/${moduleName}/schools/students`,
  async (payload, { rejectWithValue }) => {
    try {
      const { schoolId, data } = payload;
      const response = await axiosBuzzOne({
        method: 'POST',
        url: `/buzz1/schools/${schoolId}/students`,
        data,
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateBuzzOneUser = createAsyncThunk(
  `PUT/${moduleName}/users`,
  async (payload, { rejectWithValue }) => {
    try {
      const { id, data } = payload;
      const response = await axiosBuzzOne({
        method: 'PUT',
        url: `/buzz1/users/${id}`,
        data,
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateBuzzOneStudent = createAsyncThunk(
  `PUT/${moduleName}/students`,
  async (payload, { rejectWithValue }) => {
    try {
      const { id, data } = payload;
      const response = await axiosBuzzOne({
        method: 'PUT',
        url: `/buzz1/students/${id}`,
        data,
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const buzzOneSlice = createSlice({
  name: `${moduleName}`,
  initialState: {
    loading: false,
    schools: [],
    staffs: [],
    students: [],
  },
  reducers: {},
  extraReducers: {
    [getAllBuzzOneSchools.pending]: (state) => {
      state.loading = true;
    },
    [getAllBuzzOneSchools.fulfilled]: (state, action) => {
      state.loading = false;
      state.schools = action.payload;
    },
    [getAllBuzzOneSchools.rejected]: (state) => {
      state.loading = false;
    },
    [getSchoolStaffs.pending]: (state) => {
      state.loading = true;
    },
    [getSchoolStaffs.fulfilled]: (state, action) => {
      state.loading = false;
      state.staffs = action.payload.staffList;
    },
    [getSchoolStaffs.rejected]: (state) => {
      state.loading = false;
    },
    [getSchoolStudents.pending]: (state) => {
      state.loading = true;
    },
    [getSchoolStudents.fulfilled]: (state, action) => {
      state.loading = false;
      state.students = action.payload.studentList;
    },
    [getSchoolStudents.rejected]: (state) => {
      state.loading = false;
    },
  },
});

export default buzzOneSlice.reducer;
